import React, { Component } from "react";
import { Link } from "react-router-dom";

class SidebarBlog extends Component {
  render() {
    const { newsList, mediaPartners } = this.props;

    return (
      <div id="sidebar">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={60}
          data-smobile={60}
        />
        <div id="inner-sidebar" className="inner-content-wrap">
          {/* /.widget_search */}
          <div className="widget widget_follow">
            <h2 className="widget-title">
              <span>PRATITE NAS</span>
            </h2>
            <div className="follow-wrap clearfix col3 g8">
              <div class="addthis_inline_follow_toolbox"></div>
            </div>
          </div>
          {/* /.widget_gallery */}
          <div className="widget widget_instagram margin-top-51">
            <h2 className="widget-title margin-bottom-30">
              <span>O NAMA PIŠU</span>
            </h2>
            <div className="instagram-wrap data-effect clearfix col3 g10">
              {mediaPartners.map((data, idx) => (
                <div className="instagram_badge_image has-effect-icon">
                  <a
                    href={data.mediaURL}
                    className="data-effect-item"
                    style={{ border: "1px solid rgba(100,100,100,.2)" }}
                  >
                    <span className="item">
                      <img src={data.mediaSquareTh} alt={data.mediaName} />
                    </span>
                    <div className="overlay-effect bg-color-2" />
                    <div className="elm-link">
                      <span className="icon-3" />
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* /.widget_follow */}
          <div className="widget widget_lastest">
            <h2 className="widget-title">
              <span>ZADNJE NOVOSTI</span>
            </h2>
            <ul className="lastest-posts data-effect clearfix">
              {newsList.map((news) => (
                <li className="clearfix">
                  <div className="thumb data-effect-item has-effect-icon ">
                    <img src={news.srcimg} alt="imagealt" />
                    <div className="overlay-effect bg-color-2" />
                    <div className="elm-link">
                      <a
                        href={`/news?ID=${news.ID}&name=${news.title.replaceAll(
                          " ",
                          "-"
                        )}`}
                        className="icon-2"
                      />
                    </div>
                  </div>
                  <div className="text">
                    <h3>
                      <a
                        href={`/news?ID=${news.ID}&name=${news.title.replaceAll(
                          " ",
                          "-"
                        )}`}
                      >
                        {news.title}
                      </a>
                    </h3>
                    <span className="post-date">
                      <span className="entry-date">{news.date}</span>
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default SidebarBlog;
